var jobj = {};

$(function() {
    var scAtcUrl = getLink('canonical');
    var scAtcUrl_tmp = null;
    var isArticle = null;
    var media       = getMediaName(scAtcUrl);
    var returnDataFb = null;
    var returnDataLivere = null;
    var clientIp = null;
    var facebookApiUrl = 'https://graph.facebook.com/v5.0/?id=' + encodeURIComponent(scAtcUrl) + '&fields=engagement' + '&access_token=262286613837221|bTNeUttLjpgvLU3CW0Z7ah7EUFg';
    var liveApiUrl = "http://www.hani.co.kr/news/api/livere/livere.hani?refer=" + scAtcUrl_tmp;
    var ipCheckUrl = "https://ipify-dot-hani-app-256808.appspot.com/?format=jsonp";
    var expArti = /\/arti[\w\W]*\/[0-9]+\.html$/iu;

    if (expArti.test(scAtcUrl)) {
        isArticle = true;
        scAtcUrl_tmp = encodeURIComponent(scAtcUrl.substring(0, scAtcUrl.indexOf(".html", 0)).replace(/http(s|):\/\//iu, ""));
    } else {
        isArticle = false;
        scAtcUrl_tmp = encodeURIComponent(scAtcUrl.replace(/http(s|):\/\//iu, ""));
    }

    var fbData = $.ajax({
        url: facebookApiUrl, crossDomain: true, type: 'get', dataType: 'json', timeout: 3000,
        success: function(data) {
            returnDataFb = data;
            // console.log("FbData ajax ok");
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.log("fbData err "+textStatus);
        }
    });
    var liveData = (isArticle)
        ? $.ajax({
            url: liveApiUrl, crossDomain: true, type: 'get', dataType: 'jsonp', jsonp: "callback", timeout: 3000,
            success: function(data) {
                returnDataLivere = data;
                // console.log("liveData ajax ok");
            },
            error: function(jqXHR, textStatus, errorThrown) {
                returnDataLivere = null;
                jobj.cmt = 0;
                console.log("liveData err "+textStatus);
            }
        })
        : function() {
            return $.Deferred().resolve(
                {"code" : 2000, "data" : {"count": 0}, "log" : "not arti"}
            ).promise();
        };

    var ipData = $.ajax({
        url: ipCheckUrl, type: 'get', dataType: 'jsonp', jsonp:"callback", timeout: 5000,
        success: function(data) {
            clientIp = data.ip;
            // console.log("ipData ajax ok");
        },
        error: function(jqXHR, textStatus, errorThrown) {
            clientIp = "";
            console.log("ipData err "+textStatus);
        }
    });

    $.when(fbData, liveData, ipData).then(
        function() {
            // console.log("-when success-");
            if (returnDataFb && !isNaN(returnDataFb['engagement']['share_count'])
                && !isNaN(returnDataFb['engagement']['comment_count']) && !isNaN(returnDataFb['engagement']['reaction_count'])) {
                jobj.fb_cnt 	= returnDataFb['engagement']['reaction_count'] + returnDataFb['engagement']['comment_count'] + returnDataFb['engagement']['share_count'];
                jobj.fb_reaction= returnDataFb['engagement']['reaction_count'];
                jobj.fb_cmt 	= returnDataFb['engagement']['comment_count'];
                jobj.fb_share 	= returnDataFb['engagement']['share_count'];
            } else {
                jobj.fb_cnt 	= 0;
                jobj.fb_reaction= 0;
                jobj.fb_cmt 	= 0;
                jobj.fb_share 	= 0;
            }

            if (returnDataLivere && returnDataLivere['code'] == 2000 && returnDataLivere['data'] && !isNaN(returnDataLivere['data']['count'])) {
                jobj.cmt = returnDataLivere['data']['count'];
            } else {
                jobj.cmt = 0;
            }

            if(clientIp) {
                jobj.ip = clientIp;
            } else {
                jobj.ip = "";
            }

            jobj.svcurl         = scAtcUrl;
            jobj.hani_sid 	    = setSessionID();
            jobj.title 		    = getMeta('title');
            jobj.useragent 	    = navigator.userAgent;
            jobj.referer 	    = document.referrer;
            jobj.author		    = getMeta('writer');
            jobj.image		    = getMeta('image');
            jobj.publish	    = getMeta('publish');
            jobj.device         = getDeviceType();
            jobj.supportinfo    = Get_Cookie('SUPPORTINFO');        //20200917 added
            jobj.haniuid        = Get_Cookie('HANIUID');
            jobj.is_revisit     = isRevisit("hani_"+media);  //Y:revisit, N:new

            if (window.SERVER_MODE == "develop") {
                console.log(jobj);
                //ScCall(); //추후삭제 test서버 테스트용
            } else {
                haFunc.ScCall("https://hani-app-256808.appspot.com/receiver");
                // console.log(jobj);
                if (jobj.media === "sponsor") {
                    var sponsorJobj = haFunc.getSponsorObj(jobj);
                    var resSponsorCall = haFunc.ScCall("https://hani-app-256808.appspot.com/receiver/sponsor", sponsorJobj);
                    // console.log("-sponsorHA-");
                    // console.log(sponsorJobj);
                }
            }

        }, // successCall
        function() {
            console.log("-when fail-");
            console.log("returnDataFb gets");
            console.log(returnDataFb);
            console.log("returnDataLivere gets");
            console.log(returnDataLivere);
            console.log("clientIp gets");
            console.log(clientIp);
        }   //when req fails
    );

    function getMediaName(href) {
        var match = href.match(/^((http[s]?|ftp):\/)?\/?([^:\/\s]+)(?::([0-9]+))?((\/\w+)*\/)?([\w\-\.]*[^#?\s]+)?(.*)?(#[\w\-]+)?$/);
        var matches = match && {
            href: href,
            protocol: match[1],
            host: match[2],
            hostname: match[3],
            port: match[4],
            path: match[5],
            search: match[6],
            hash: match[7]
        }
        return (function(host, path) {
            var ret;
            path = (path === undefined) ? "" : path;

            switch (host) {
                case "www.hani.co.kr":
                case "hani.co.kr":
                case "m.hani.co.kr":
                    if (path.match("arti\/multihani") || path.match("pictorial") || path.match("special") || path.match("photo")) {
                        ret = "photo";
                    } else {
                        ret = "news";
                    }
                    break;
                case "pictorial.hani.co.kr":
                case "multihani.hani.co.kr":
                    ret = "photo";
                    break;
                case "h21.hani.co.kr":
                    ret = "h21";
                    break;
                case "www.seouland.com":
                case "borough.seouland.com":
                    ret = "seouland";
                    break;
                case "special.hani.co.kr":
                case "plug.hani.co.kr":
                case "well.hani.co.kr":
                case "ecotopia.hani.co.kr":
                case "photovil.hani.co.kr":
                case "babytree.hani.co.kr":
                    ret = "special";
                    break;
                case "english.hani.co.kr":
                    ret= "english";
                    break;
                case "japan.hani.co.kr":
                    ret = "japan";
                    break;
                case "china.hani.co.kr":
                    ret = "china";
                    break;
                case "search.hani.co.kr":
                    ret = "search";
                    break;
                case "support.hani.co.kr":
                    ret = "sponsor";
                    break;
                default :
                    ret = "etc";
            }
            return ret;
        })(matches['hostname'], matches['path']);
    }

    function Set_Cookie(name, value, hours) {
        if (hours) {
            var date = new Date();
            date.setTime(date.getTime()+(hours*60*60*1000));
            var expires = "; expires="+date.toGMTString();
        }
        else var expires = "";
        document.cookie = name+"="+value+expires+"; path=/";
    }

    function Get_Cookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    function setSessionID() {
        var timestamp = Math.floor(+ new Date() / 1000);    //10자리(초단위)
        var randomInt = function (positionalNumber) {
            var randomValue = Math.random() * (Math.pow(10, positionalNumber)); //0 ~ 10의 n승-1까지 범위
            return Math.floor(randomValue);
        };

        if (!Get_Cookie("hani_sid")) {
            Set_Cookie("hani_sid", clientIp + "." + randomInt(9) + "."  + timestamp , 24*30);  //session ID : client IP + random + timestamp, 24X30 hour
        }
        return Get_Cookie("hani_sid");
    }

    function isRevisit(name) {  //Y:revisit, N::new
        var timestamp = Math.floor(+ new Date() / 1000);    //10자리(초단위)
        var randomInt = function (positionalNumber) {
            var randomValue = Math.random() * (Math.pow(10, positionalNumber)); //0 ~ 10의 n승-1까지 범위
            return Math.floor(randomValue);
        };

        if (!Get_Cookie(name)) {
            Set_Cookie(name, clientIp + "." + randomInt(9) + "."  + timestamp , 24*30);  //session ID : client IP + random + timestamp, 24X30 hour
            return 'N';         //new visit
        }else {
            return 'Y';
        }
    }

    function getMeta(metaName) {
        var metas = document.getElementsByTagName('meta');

        for (var i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') === metaName) {
                return metas[i].getAttribute('content');
            }
        }
        return '';
    }

    function getLink(relName) {
        var links = document.getElementsByTagName('link');
        for (var i = 0; i < links.length; i++) {
            if (links[i].getAttribute('rel') === relName) {
                return links[i].getAttribute('href');
            }
        }
        return '';
    }

    function getDeviceType() {
        var filter = "win16|win32|win64|mac|macintel";
        var vWebType = "";

        if (navigator.platform) {
            if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
                return "m";
            }else {
                return "p";
            }
        }
    }
});

var haFunc = {
    ScCall : function(haUrl) {
        var jsonParam = JSON.stringify(jobj);
        $.ajax({
            url 			:  haUrl,
            type 			: 'POST',
            data			: jsonParam,
            crossDomain		:  true,
            dataType        : 'json',
            json			: 'callback',
            ContentType		:'application/json; charset=UTF-8'
        });
    },
    getSponsorObj : function (jobj) {   // 기존 HA obj(jobj) 를 바탕으로 후원전용 HA obj 를 만들어 리턴한다.
        var root_referrer = (function() {
            if (window.sessionStorage) {
                var rootRef = window.sessionStorage.getItem('hani_root_referrer');
                if (rootRef == null || rootRef === undefined || rootRef === 'undefined') {
                    window.sessionStorage.setItem('hani_root_referrer', ((document.referrer) ? document.referrer : ''));
                }
                return window.sessionStorage.getItem('hani_root_referrer');
            } else {
                return '';
            }
        })();
        var fromPageInfo = (function() {    // from_media, from_content_type, from_article_id, from_banner_position
            function urlParam(key) {
                var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.search);
                return (results == null) ? null : results[1] || 0;
            }
            return { from_media: urlParam('media'), from_content_type: urlParam('content_type'),
                from_article_id: urlParam('article_id'), from_banner_position: urlParam('banner_position')
            };

        })();
        return {
            hani_sid: jobj.hani_sid,
            svcurl: jobj.svcurl,
            referrer: document.referrer,
            device: jobj.device,
            supportinfo: jobj.supportinfo,
            haniuid: jobj.haniuid,
            is_revisit: jobj.is_revisit,
            ip: jobj.ip,
            root_referrer: root_referrer,
            media : fromPageInfo.from_media,
            content_type: fromPageInfo.from_content_type,
            article_id: fromPageInfo.from_article_id,
            banner_position: fromPageInfo.from_banner_position
        };
    },
    callSecondPhase : function() {
        console.log('sponsorFunc.callSecondPhase');
    }
};